/* Точка входа, экспорт MetaOnboarding и запуск инициализации */
window.MetaOnboarding = {
    init,
    handleTicketClick,
    openModal,
    closeModal,
    getUser,
    isRegistered,
    isDayUnlocked: (d) => (window.isDayUnlocked ? window.isDayUnlocked(d) : false),
    getUnlockedDays: () => (window.getUnlockedDays ? window.getUnlockedDays() : []),
    getReferralId,
    getReferralLink,
    getShareUrl,
    getReferralCount,
    setReferralCount,
    getInvitedFriends,
    addInvitedFriend,
    updateReferralUI,
    requestBotWriteAccess,
    triggerHaptic,
    handleFormSubmit,
    getBonusBalance,
    setBonusBalance,
    updateBonusUI,
    openBonusModal,
    closeBonusModal,
    openPayModal,
    openAllDaysCheckout,
    openExternalPaymentUrl,
    closePayModal,
    simulatePaymentSuccess,
    onPaymentInitiated,
    openQuestionnaireModal,
    closeQuestionnaireModal,
    handleQuestionnaireSubmit,
    updateLandingCTA,
    updateLandingProgramUI: () => (window.updateLandingProgramUI ? window.updateLandingProgramUI() : false),
    checkCelebration,
    showCelebrationModal,
    closeCelebrateModal,
    unlockDayWithBonus: () => false,
    addTestBonuses: () => false,
    updateDashboardDayCards,
    updateDashboardDaysUI,
    startDripCountdowns,
    initVideoTracking,
    submitLessonAnswer,
    openLiveBroadcast,
    closeLiveBroadcastWait,
    setLiveUrlForDay,
    openVideoPlayer,
    closeVideoPlayer,
    closeRecordWait,
    getVideoUrlForDay,
    shareInvite,
    copyPersonalLink: window.copyPersonalLink,
    copyReferralLink: window.copyReferralLink,
    copyToClipboard,
    showToast,
    isVKPlatform,
    updateBottomNavForDay4,
    trackCourseAction,
    openCourseTariff,
    isChannelSubscribed: () => window.isChannelSubscribed(),
    confirmChannelSubscription: () => window.confirmChannelSubscription(),
    handleChannelGateOpenLink: (e, url) => window.handleChannelGateOpenLink(e, url)
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }